import { useEffect } from 'react';
import { useCookieConsent } from '@monovo/onetrust';
import mixpanel from 'mixpanel-browser';
import { loadQualtricsScript } from './loadQualtricsScript';
import { datadogRum } from '@datadog/browser-rum';

export const useLoadScriptsOnConsent = () => {
  const cookieConsents = useCookieConsent();

  useEffect(() => {
    if (
      cookieConsents?.performance &&
      process.env.NX_PUBLIC_MIXPANEL_ID &&
      !mixpanel.has_opted_in_tracking()
    ) {
      mixpanel.opt_in_tracking();
    }

    if (cookieConsents?.performance) {
      datadogRum.setTrackingConsent('granted');
      loadQualtricsScript();
    } else {
      // opt out by default
      if (process.env.NX_PUBLIC_MIXPANEL_ID) mixpanel.opt_out_tracking();
      datadogRum.setTrackingConsent('not-granted');
    }
  }, [cookieConsents?.performance]);
};
